<template>
  <div
    class="m-dropdown-content m-dropdown-content-left"
    id="MoleculeFeedProjectsSearchDropDownFilters"
  >
    <form
      autocomplete="off"
      spellcheck="false"
      @submit.prevent="searchFilter"
    >
      <section class="m-dropdown-section">
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              Formaciones
            </a>
            <div class="m-dropdown-sublist display-flex-row">
              <div
                v-for="(projectType, index) in projectsType"
                :key="index"
              >
                <AtomRadioButtonPrimary
                  v-model.number="filter.project_type"
                  :radio-button-primary="radioButtonPrimary.projectType"
                  :text="projectType.name"
                  :value="projectType.id"
                  wrapperClass="a-input-side margin-top-xsmall margin-bottom-xsmall"
                />
              </div>
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              Estados
            </a>
            <div class="m-dropdown-sublist m-dropdown-sublist-scrollable">
              <ul>
                <li
                  v-for="(state, index) in states"
                  :key="index"
                >
                  <AtomCheckboxPrimary
                    v-model="filter.state"
                    inputStyle="assets"
                    name="estado"
                    :text="state.name"
                    :value="state.id"
                    wrapper-class="margin-zero"
                  />
                </li>
              </ul>
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              Orden
            </a>
            <div class="m-dropdown-sublist display-flex-row">
              <div
                v-for="(sortType, index) in sortTypes"
                :key="index"
              >
                <AtomRadioButtonPrimary
                  v-model.number="filter.sort_type"
                  v-show="sortType.id !== 1 || (sortType.id === 1 && filter.project_type !== 11)"
                  :disabled="sortType.id === 1 && filter.project_type === 11"
                  :radio-button-primary="radioButtonPrimary.sortType"
                  :text="sortType.name"
                  :value="sortType.id"
                  wrapperClass="a-input-side margin-top-xsmall margin-bottom-xsmall"
                />
              </div>
            </div>
          </li>
        </ul>
      </section>
      <footer class="m-dropdown-footer">
        <button
          class="a-button-dropdown-secondary"
          @click="reload"
        >
          Actualizar
        </button>
        <button
          class="a-button-primary a-button-billing-primary a-button-dropdown-primary"
          type="submit"
        >
          Filtrar
        </button>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeFeedProjectsSearchDropDownFilters',

  props: {
    filterSeted: Object
  },

  data () {
    return {
      radioButtonPrimary: {
        sortType: {
          labelClass: 'a-radiobutton-assets-primary font-size-small',
          name: 'sort-type'
        },

        projectType: {
          labelClass: 'a-radiobutton-assets-primary font-size-small',
          name: 'project-type'
        }
      },

      filter: {
        name: '',
        project_type: 11,
        state: [0, 1],
        sort_type: 0
      },

      projectsType: [
        {
          id: 11,
          name: 'Todas'
        },

        {
          id: 0,
          name: 'Cursos'
        },

        {
          id: 1,
          name: 'Mapas'
        }
      ],

      sortTypes: [
        {
          id: 1,
          name: 'Predeterminado'
        },

        {
          id: 0,
          name: 'Fecha de Creación'
        },

        {
          id: 2,
          name: 'Alfabético A-Z'
        },

        {
          id: 3,
          name: 'Mensajes Pendientes'
        },

        {
          id: 4,
          name: 'Alumnos Activos'
        }
      ],

      states: [
        {
          id: 0,
          name: 'Borradores'
        },

        {
          id: 1,
          name: 'Publicados'
        }
      ]
    }
  },

  watch: {
    'filter.project_type' () {
      if (this.filter.project_type === 11 && this.filter.sort_type === 1) {
        this.filter.sort_type = 0
      } else if ((this.filter.project_type === 0 || this.filter.project_type === 1) && this.filter.sort_type === 0) {
        this.filter.sort_type = 1
      }
    },

    filterSeted: {
      deep: true,

      handler () {
        this.filter = Object.assign({}, this.filterSeted)
      }
    }
  },

  methods: {
    reload () {
      this.filter = {
        name: '',
        project_type: 11,
        sort_type: 0,
        state: [0, 1]
      }

      this.$emit('reload')
    },

    searchFilter () {
      this.$dropDown.switchDropDown('MoleculeFeedProjectsSearchDropDownFilters')
      this.$emit('searchFilter', this.filter)
    }
  }
}
</script>
